export const eventSesseionStart = `<svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 14.2679C25.3333 15.0377 25.3333 16.9623 24 17.7321L12 24.6603C10.6667 25.4301 9 24.4678 9 22.9282L9 9.0718C9 7.5322 10.6667 6.56995 12 7.33975L24 14.2679Z" fill="currentColor"/>
</svg>`;
